import { List } from "@/shared/components/GenericSearchBar/model/List";
import {
  COLLECTIONS_NAME,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STATE } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ACTION_PLAN_CONSTANTS,
  EVENT_VALID_NAME_FIELD
} from "./../../constants/ActionPlanConstants";
import { ActionPlanService } from "../../services/ActionPlanService";
import { Utils } from "@/shared/utils/utils";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";

@Component({
  name: "HeaderActionPlan",
  components: {
    DynamicSelect
  }
})
export default class HeaderActionPlan extends Vue {
  @Inject() actionPlanService!: ActionPlanService;

  @Prop() private name!: string;
  @Prop() private category!: string;
  @Prop() private state!: boolean | string;
  @Prop() categories!: List[];
  @Prop() isEditing!: boolean;

  cardClass = STYLE_CLASSES.CARD_2;
  card2Class = STYLE_CLASSES.CARD_PADING;
  LABEL_STATUS = STATE.ACTIVE;
  switchClass = STYLE_CLASSES.SWITCH;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  TITLES = ACTION_PLAN_CONSTANTS.TITLES;
  rules = {
    name: [
      FORM_VALIDATORS.REQUIRED_FIELD,
      FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
    ],
    category: [FORM_VALIDATORS.REQUIRED_FIELD, FORM_VALIDATORS.REQUIRED_ARRAY]
  };
  errorsName: string[] = [];
  categoryConfigList: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.categories.map(item => {
      return { id: item.key, name: item.name };
    }),
    messageLabel: this.TITLES.CATEGORY,
    required: true,
    disabled: this.isEditing
  };

  @Watch("isEditing")
  setDisabled() {
    this.categoryConfigList.disabled = this.isEditing;
  }

  get stateLocal() {
    return (
      this.state == STATE.ACTIVE ||
      (typeof this.state == "boolean" && this.state)
    );
  }
  set stateLocal(e) {
    this.$emit("update:state", e);
  }
  get nameLocal() {
    return this.name.trim();
  }
  set nameLocal(e) {
    this.$emit("update:name", e.trim());
  }
  get categoryLocal() {
    if (
      this.isEditing &&
      !this.categories.find(category => category.name === this.category)
    ) {
      this.categoryConfigList.listAll.push({
        id: this.category,
        name: this.category
      });
    }
    return [{ id: this.category ?? "", name: this.category ?? "" }];
  }
  set categoryLocal(e: [{ id: string; name: string }]) {
    this.$emit("update:category", e[0].id);
  }
  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.ACTION_PLAN,
      this.nameLocal
    );
    this.$emit(EVENT_VALID_NAME_FIELD, !this.errorsName.length);
  }
}
